import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

interface Subjects {
  [eventName: string]: Subject<any>;
}


@Injectable({
  providedIn: 'root'
})
export class EventBrokerService {

  #subjects: Subjects = {};
  constructor() { }

  private getSubject(eventName: string): Subject<any> {
    let subject = this.#subjects[eventName];
    if (!subject) { subject = this.#subjects[eventName] = new Subject<any>(); }
    return subject;
  }

  publish(eventName: string, eventData: any): void {
    this.getSubject(eventName).next(eventData);
  }

  subscribe<T>(eventName: string, eventHandler: (eventData: T) => void): Subscription {
    return this.getSubject(eventName).subscribe(eventHandler);
  }
}
